import { AxiosPromise } from 'axios';
import Http from '../../shared/http';
import {
  NetworkId,
  API_PATH_NETWORK_ID,
} from './networkId.types';
import { ServerResponse, WithAuditDetails } from '../types';

const http = Http.getHttp();

export function getNetworkIdList(
  deliveryFunctionId: string,
): AxiosPromise<ServerResponse<NetworkId>> {
  return http.get(`${API_PATH_NETWORK_ID}/${deliveryFunctionId}`);
}

export function getNetworkId(
  deliveryFunctionId: string,
  id: string,
): AxiosPromise<ServerResponse<NetworkId>> {
  const encodedId = encodeURIComponent(id);

  return http.get(`${API_PATH_NETWORK_ID}/${deliveryFunctionId}/${encodedId}`);
}

export function createNetworkId(
  deliveryFunctionId: string,
  body: WithAuditDetails<NetworkId>,
): AxiosPromise<ServerResponse<NetworkId>> {
  return http.post(`${API_PATH_NETWORK_ID}/${deliveryFunctionId}`, body);
}

export function deleteNetworkId(
  deliveryFunctionId: string,
  id: string,
  body: WithAuditDetails<void>,
): AxiosPromise<ServerResponse<NetworkId>> {
  return http.delete(`${API_PATH_NETWORK_ID}/${deliveryFunctionId}/${id}`, { data: body.auditDetails });
}
